import superAdminReducer from "./superAdminReducers.js";
import studentReducer from "./studentReducers.js";
import internalUserReducer from "./internalUserReducer.js";
import studentDashboardReducer from "./studentDashboardReducers.js";
import industryuserReducer from "./industryUserReducers.js";
import adminDashboardReducer from "./adminDashboardReducer.js";
import merchantreducer from "./merchantReducer.js";


const storeReducer = {
  student: studentReducer,
  superadmin: superAdminReducer,
  internaluser: internalUserReducer,
  studentdashboard: studentDashboardReducer,
  industry: industryuserReducer,
  admindashboard: adminDashboardReducer,
  merchant: merchantreducer
};

export default storeReducer;
